/**
 * Created by brunopoeta on 27/03/17.
 */

const domain = (window.location.href && window.location.href.indexOf('www.unasp.br') > -1) ? 'https://www.unasp.br' : (window.location.href.indexOf('eadadventista.unasp.br') > -1 ? 'https://eadadventista.unasp.br' : (window.location.href.indexOf('eadadventista.unasp.br') > -1 ? 'https://eadadventista.unasp.br' : (window.domain || 'http://dev.unasp.br')));
const researchDomain = window.location.href.indexOf('/ciencia') > -1 ? 'https://www.unasp.br/ciencia' : domain.indexOf('www.unasp.br') > -1 ? 'https://www.unasp.br' : 'http://dev.unasp.br';
const newsDomain = window.location.href.indexOf('/sites') > -1 ? window.location.href : domain.indexOf('www.unasp.br') > -1 ? 'https://www.unasp.br/noticias/' : 'http://noticias.unasp.dev.br/';
const articlesDomain = window.location.href.indexOf('/sites') > -1 ? window.location.href : domain.indexOf('www.unasp.br') > -1 ? 'https://www.unasp.br/blog/' : 'http://unasp.blog.internal.nextt.com.br/';
const coursesDomain = window.location.href.indexOf('/sites/nominata') > -1 ? 'https://www.unasp.br/ec/sites/nominata' : window.location.href.indexOf('/sites/trainee') > -1 ? 'https://www.unasp.br/ec/sites/trainee' : (window.location.href.indexOf('eadadventista.unasp.br') > -1 ? 'https://eadadventista.unasp.br' : (window.location.href.indexOf('eadadventista.unasp.br') > -1 ? 'https://eadadventista.unasp.br' : 'https://www.unasp.br'));
const calendarDomain = window.location.href.indexOf('/mestrado/educacao/calendario') > -1 ? 'https://www.unasp.br/mestrado/educacao/calendario' : (window.location.href.indexOf('/calendarioeb') > -1 ? 'https://www.unasp.br/calendarioeb' : (window.location.href.indexOf('/on') > -1 ? 'https://www.unasp.br/on' : (domain.indexOf('www.unasp.br') > -1 ? 'https://www.unasp.br/calendario' : 'http://dev.calendario.unasp.edu.br')));
const eventsDomain = domain.indexOf('www.unasp.br') > -1 ? 'https://www.unasp.br/eventos' : 'http://unasp.eventos.internal.nextt.com.br';
if (window.location.href.indexOf('/mestrado') > -1) {
    let res = window.location.pathname.split('/');
    const masterDomain = domain + '/' + res[1] + '/' + res[2];
} else {
    const masterDomain = domain;
}

console.log('domain', domain);
console.log('coursesDomain', coursesDomain);
console.log('calendarDomain', calendarDomain);
console.log('eventsDomain', eventsDomain);
console.log('masterDomain', masterDomain);

module.exports = {
    // ajax: domain + '/wop/wp-admin/admin-ajax.php',
    ajax: `${(domain.indexOf('www.unasp.br') > -1) ? 'https://www.unasp.br' : 'http://dev.unasp.br/wop'}/wp-admin/admin-ajax.php`,
    areas: coursesDomain + '/wp-json/custom_api/v1/areas',
    articles: articlesDomain + 'wp-json/custom_api/v1/posts',
    calendar: calendarDomain + '/wp-json/custom_api/v1/calendar',
    calendarAjax: calendarDomain + '/wp-admin/admin-ajax.php',
    contact: {
        phones: domain + '/wp-json/custom_api/v1/phones'
    },
    courses: coursesDomain + '/wp-json/custom_api/v1/courses',
    domain: domain,
    events: eventsDomain + '/wp-json/custom_api/v1/events',
    examLocations: domain + '/wp-json/custom_api/v1/places-of-proof',
    faq: domain + '/wp-json/custom_api/v1/faq',
    newsAddView: newsDomain + '/wp-json/custom_api/v1/news/add-view',
    news: newsDomain + 'wp-json/custom_api/v1/news',
    notices: domain + '/wp-json/custom_api/v1/notices',
    research: researchDomain + '/wp-json/custom_api/v1/research-and-extensions',
    search: {
        courses: domain + '/wp-json/custom_api/v1/courses',
        ead: domain + '/wp-json/custom_api/v1/courses_ead',
        events: domain + '/wp-json/wp/v2/events'
    },
    statesAndCities: domain + '/wp-json/custom_api/v1/states-and-cities',
    unities: {
        ead: domain + '/wp-json/custom_api/v1/poles',
        presential: domain + '/wp-json/custom_api/v1/presential'
    },
    registration: {
        extension: domain + '/wp-json/custom_api/v1/registration_extension',
    },
    ead: {
        loginTracker: domain + '/wp-json/custom_api/v1/ead-tracker/',
        login: 'https://unasp.mrooms.net/login/index.php',
    },
    masters: {
        files: masterDomain + '/?rest_route=/custom_api/v1/filtered-files/',
        dissertations: masterDomain + '/?rest_route=/custom_api/v1/dissertations/',
        articles: masterDomain + '/wp-json/custom_api/v1/articles/',
        previous_events: masterDomain + '/?rest_route=/custom_api/v1/previous-events/',
    }
};